export default "__VITE_ASSET__BhrHXCwS__"